export default __webpack_public_path__ + "static/media/arrowLeftIcon.e8389202.svg";